import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import type {
  CaptchaDefinition,
  CaptchaLanguageKey,
  ICaptchaMapperProps,
} from '../Captcha.types';
import { WIX_RECAPTCHA_LANGUAGE_MAP } from '../constants';

export const props = withCompInfo<ICaptchaMapperProps, CaptchaDefinition>()(
  ['language', 'compData'],
  ({ language, compData }) => {
    return {
      useV3: compData.useV3,
      language:
        WIX_RECAPTCHA_LANGUAGE_MAP[language as CaptchaLanguageKey] || 'en',
    };
  },
);

export default createComponentMapperModel({
  props,
});
